import React, { useEffect, useState } from "react";

import { connect } from "react-redux";

import Loading from "./components/Loading";
import { imported } from "react-imported-component";
import { AuthDataProvider } from "./main/context/AuthDataContext";
import { UserDataProvider } from "./main/context/UserDataContext";
import { ApplicationDataProvider } from "./main/context/ApplicationDataContext";
import { DataLoadingProvider } from "./main/context/DataLoadingContext";
import tableMetaData from "./data/clioTables";
import { DataSelectionProvider } from "./application/preferences/components/data/context/DataSelectionContext";
import { updateSelectionPreferences } from "./actions/selectedActions";
// code splitting for performance
// only load what we need based on route
const MainContainer = imported(() => import("./main/MainContainer"), {
  LoadingComponent: () => <Loading message="Loading Main Page..."></Loading>,
});
const App = (props) => {
  useEffect(() => {
    // app title should reflect which env it is running in
    document.title = `Report Zone ${process.env.NODE_ENV === "production" ? "App" : "Dev"}`;
  }, []);

  return props.authState === "signedIn" ? (
    <AuthDataProvider init={props.authData}>
      <DataLoadingProvider tableNames={Object.keys(tableMetaData.tables)} pollingInterval={1000}>
        <UserDataProvider>
          <ApplicationDataProvider>
            <DataSelectionProvider
              userId={props.authData.attributes.sub}
              updateSelectionPreferences={props.updateSelectionPreferences}
            >
              <MainContainer authData={props.authData} {...props} />
            </DataSelectionProvider>
          </ApplicationDataProvider>
        </UserDataProvider>
      </DataLoadingProvider>
    </AuthDataProvider>
  ) : null;
};

const mapStateToProps = (state, ownProps) => ({});

// maps dispatch functions
const mapDispatchToProps = (dispatch, ownProps) => ({
  updateSelectionPreferences: (params) => dispatch(updateSelectionPreferences(params)),
});
export default connect(mapStateToProps, mapDispatchToProps)(App);
